// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import Portfolio from "./components/Portfolio";

function RedirectToExternal({ url }) {
	React.useEffect(() => {
		window.location.replace(url);
	}, [url]);

	return <p>Redirecting to {url}</p>;
}

export default function App() {
	return (
		<Routes>
			<Route path="/" element={<Portfolio />} />
			<Route
				path="/resume"
				element={
					<RedirectToExternal url="https://virginiatech-my.sharepoint.com/:b:/g/personal/mdigiorgio_vt_edu/IQC2LATr3Sh9TrwkiO9Qq7PzAf9QVwppQq_entmBgxrbuzI?e=2tro7P" />
				}
			/>
			<Route
				path="/businesscard"
				element={<RedirectToExternal url="/#businesscard" />}
			/>
		</Routes>
	);
}
